export default {"src":"/_next/static/media/logo-poap-slateus.5aaa662e.svg","height":100,"width":100};